<div class="modal-container">
  <button
    id="modalEditarVideo"
    #modalEditarVideo
    data-bs-toggle="modal"
    data-bs-target="#modelND"
    hidden="hidden">
    Launch
  </button>
  <div
    class="modal fade"
    id="modelND"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title h5-tipografia-govco">Actualizar Video</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form [formGroup]="videoForm" (ngSubmit)="submitForm()">
            <div class="mb-3">
              <label for="videoName" class="form-label">Nombre del video</label>
              <input
                type="text"
                class="form-control"
                id="videoName"
                formControlName="videoName" />
              <div
                *ngIf="
                  videoForm.get('videoName')?.invalid &&
                  videoForm.get('videoName')?.touched
                "
                class="text-danger">
                El nombre del video es requerido.
              </div>
            </div>
            <div class="mb-3">
              <label for="videoUrl" class="form-label">URL del video</label>
              <input
                type="text"
                class="form-control"
                id="videoUrl"
                formControlName="videoUrl" />
              <div
                *ngIf="
                  videoForm.get('videoUrl')?.invalid &&
                  videoForm.get('videoUrl')?.touched
                "
                class="text-danger">
                La URL del video es requerida.
              </div>
            </div>
            <button
              type="submit"
              class="btn-govco fill-btn-govco mx-auto"
              [disabled]="videoForm.invalid">
              Subir video
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
